import type { ContenidoAyuda, ItemAyuda } from "@/ui/AyudaVista";

/**
 * Ayuda de Ventas (catálogo de equipos vendidos). Antes, el «?» con globito y
 * los tooltips de «Cargas», «Subir archivo» y «Revertir».
 */
export function ayudaVentas({ esAdmin }: { esAdmin: boolean }): ContenidoAyuda {
  const admin: ItemAyuda[] = esAdmin
    ? [
        {
          label: "Subir archivo",
          text: "Sube el Excel de ventas del CRM (.xlsx). Puedes volver a subir el histórico completo sin miedo: lo que ya estaba no se duplica.",
        },
        {
          label: "Cargas",
          text: "El historial de archivos subidos, con cuántas ventas nuevas y repetidas trajo cada uno.",
        },
        {
          label: "Revertir (en Cargas)",
          text: "Borra las ventas que ESA carga metió como nuevas y la quita del historial (te pide confirmar). Las ventas de otras cargas no se tocan; si te equivocas, vuelve a subir el archivo.",
        },
      ]
    : [];
  return {
    manual: "ventas",
    intro: (
      <>
        <p>
          La lista de ventas del CRM de Emprenet, para comprobar si un equipo lo vendimos nosotros:
          a quién, cuándo y con qué cotización. Aquí no se captura nada a mano.
        </p>
        <p>
          Si un equipo NO aparece, probablemente no lo vendimos: revísalo antes de dar soporte. Ojo:
          el mes en curso puede no estar cargado todavía (mira «última carga» arriba de la lista).
        </p>
      </>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          {
            label: "Buscador",
            text: "Busca por IMEI (o ICCID o número de serie, desde 4 dígitos; puedes pegarlo con espacios), empresa, contacto, cotización o lo que diga el concepto, como el modelo. No distingue mayúsculas ni acentos.",
          },
          {
            label: "Tocar una venta",
            text: "La abre ahí mismo: contacto, cotización, concepto completo y todos sus equipos. Tócala otra vez para cerrarla.",
          },
          {
            label: "Tocar un número (IMEI, cotización)",
            text: "Lo copia al portapapeles.",
          },
          { label: "← Anterior / Siguiente →", text: "Cambia de página cuando hay muchos resultados." },
          ...admin,
        ],
      },
      {
        titulo: "Qué significa cada indicador",
        items: [
          {
            label: (
              <span className="rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-amber-300">
                Garantía
              </span>
            ),
            text: "Venta de una garantía: el concepto dice «garantía» o trae el equipo con falla y el que lo reemplazó. Si un IMEI sale en dos ventas, es su historial: la venta original y su garantía.",
          },
          {
            label: (
              <span className="text-[9px] uppercase tracking-wide">
                <span className="text-red-400">falla</span> / <span className="text-emerald-400">nuevo</span>
              </span>
            ),
            text: "En una garantía: el equipo que llegó con falla y el que lo reemplazó.",
          },
          {
            label: "Número resaltado",
            text: "Es el que coincide con lo que buscaste.",
          },
          { label: "Equipos", text: "Cuántos equipos con número trae la venta; «—» si no trae (licencias, accesorios o envío)." },
        ],
      },
    ],
  };
}
